<template>
    <CircleButton icon="plus" />
</template>
<script>
import CircleButton from "components/globals/CircleButton"

export default {
    components: { CircleButton },
    name: "AddButton"
}
</script>
